import { render, staticRenderFns } from "./screen.vue?vue&type=template&id=208a854b&scoped=true"
import script from "./screen.vue?vue&type=script&lang=js"
export * from "./screen.vue?vue&type=script&lang=js"
import style0 from "./screen.vue?vue&type=style&index=0&id=208a854b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208a854b",
  null
  
)

export default component.exports